"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockSalesOrderItems = exports.mockSerializedSalesOrderItems = exports.mockBuiltSalesOrderItems = exports.mockSerializedBuiltSalesOrderItems = exports.mockFixedSalesOrderItems = void 0;
const lodash_1 = require("lodash");
const SalesOrderItemFixed_1 = require("../../../models/SalesOrderItemFixed");
const SalesOrderItemBuilt_1 = require("../../../models/SalesOrderItemBuilt");
const guid_1 = require("../../../../../../apis/spg/util/guid");
const mockProducts_1 = require("./mockProducts");
const ProductBlueprint_1 = require("../../../models/ProductBlueprint");
const mockSerializedFixedSalesOrderItems = [
    {
        salesOrderId: (0, guid_1.createGuid)(),
        quantity: 2,
        totalPrice: 8,
        priceDiscounted: null,
        product: mockProducts_1.mockSerializedStockedProducts[0]
    },
    {
        salesOrderId: (0, guid_1.createGuid)(),
        quantity: 1,
        totalPrice: 4,
        priceDiscounted: null,
        product: mockProducts_1.mockSerializedStockedProducts[1]
    },
    {
        salesOrderId: (0, guid_1.createGuid)(),
        quantity: 1,
        totalPrice: 4,
        priceDiscounted: null,
        product: mockProducts_1.mockSerializedStockedProducts[2]
    }
];
exports.mockFixedSalesOrderItems = mockSerializedFixedSalesOrderItems.map((salesOrderItemFixed) => SalesOrderItemFixed_1.SalesOrderItemFixed.unserialize(salesOrderItemFixed));
exports.mockSerializedBuiltSalesOrderItems = [
    {
        salesOrderId: (0, guid_1.createGuid)(),
        quantity: 1,
        totalPrice: 12.4,
        productBlueprint: mockProducts_1.mockSerializedProductBlueprints[0],
        selectedProducts: mockProducts_1.mockSerializedProductBlueprints[0].products.map((serializedBluePrintStockedProduct) => ({
            quantity: 1,
            product: serializedBluePrintStockedProduct
        }))
    }
];
exports.mockBuiltSalesOrderItems = exports.mockSerializedBuiltSalesOrderItems.map((serializedSalesOrderItemBuilt) => {
    const productBlueprint = (0, lodash_1.cloneDeep)(ProductBlueprint_1.ProductBlueprint.unserialize(serializedSalesOrderItemBuilt.productBlueprint));
    const newSalesOrderItemBuilt = new SalesOrderItemBuilt_1.SalesOrderItemBuilt(productBlueprint);
    // rebuild full selected products
    const selectedProducts = serializedSalesOrderItemBuilt.selectedProducts.map((selectedProduct) => (Object.assign(Object.assign({}, selectedProduct), { 
        // get full product
        product: newSalesOrderItemBuilt.productBlueprint.findProductById(selectedProduct.product.productId) })));
    newSalesOrderItemBuilt.initialise(selectedProducts);
    newSalesOrderItemBuilt.quantity = serializedSalesOrderItemBuilt.quantity;
    newSalesOrderItemBuilt.totalPrice = newSalesOrderItemBuilt.price;
    newSalesOrderItemBuilt.priceDiscounted =
        serializedSalesOrderItemBuilt.priceDiscounted || null;
    return newSalesOrderItemBuilt;
});
exports.mockSerializedSalesOrderItems = []
    .concat(mockSerializedFixedSalesOrderItems)
    .concat(exports.mockSerializedBuiltSalesOrderItems);
exports.mockSalesOrderItems = []
    .concat(exports.mockFixedSalesOrderItems)
    .concat(exports.mockBuiltSalesOrderItems);
//# sourceMappingURL=mockSalesOrderItems.js.map